/** @format */

export interface AdditionalData {
  tagSectionNum: number;
  widgetTypeTag?: string;
}
